import { Component, OnInit, ViewChild } from '@angular/core';
import { StorageHelper } from '../helpers/StorageHelper';
import { BaseComponent } from '../classes/BaseComponent';
import { InfoService } from '../info.service';
import { CountryService } from '../country.service';
import { CookiesHelper } from '../helpers/CookiesHelper';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-cookies-message',
  templateUrl: './cookies-message.component.html',
  styleUrls: ['./cookies-message.component.scss']
})
export class CookiesMessageComponent extends BaseComponent implements OnInit {

  cookiesAcceptedValue = StorageHelper.getInstance().get(StorageHelper.keys.cookiesAccepted);
  cookiesBannerDismissed = ["essentials", "accepted"].includes(this.cookiesAcceptedValue);
  isEU: boolean = false;

  @ViewChild('cookieSettingsModal', {static: false}) cookieSettingsModal;

  constructor(private infoService: InfoService, private countryService: CountryService) {
    super();
  }

  ngOnInit() {
    // Always fetch user location to set isEU flag (needed for Cookie Settings menu item)
    this.getUserLocation().subscribe(res => {
      if(!this.cookiesBannerDismissed && this.isEU == false) {
        // If we're not in the EU, we can start collect info directly. No need to wait for the user to consent to the cookies
        CookiesHelper.accept(false);
      }
    }, err => {});

    if(!this.cookiesBannerDismissed) {
      if(this.cookiesAcceptedValue == "accepted") {
        CookiesHelper.loadGoogleScripts();
      }
    }
  }

  getUserLocation(): Observable<any> {
    // Documentation on how the tap function works
    // https://upmostly.com/angular/what-does-the-tap-operator-do-in-angular-rxjs
    return this.infoService.getUserLocation().pipe(tap(res => {
      this.isEU = res["isEU"];
      this.countryService.isEU = this.isEU;
    }));
  }

  settings() {
    this.cookiesBannerDismissed = true;
    this.cookieSettingsModal.open();
  }

  applySettings(value: string) {
    if(value == "essentials") {
      this.decline();
    }
    else {
      this.accept();
    }
    this.cookieSettingsModal.close();
  }

  decline() {
    this.cookiesBannerDismissed = true;
    CookiesHelper.decline();
  }

  accept() {
    this.cookiesBannerDismissed = true;
    CookiesHelper.accept();
  }

}
